import moment from "moment";

export default {

  install(Vue, options) {

    moment.locale('en-gb');

    Vue.filter('msm_date', function (value) {
      if (!value) return ''

      return moment(value).format('L');
    })

    Vue.filter('msm_datetime', function (value) {
      if (!value) return ''

      return moment(value).format('L LT');
    })

    Vue.filter('msm_time', function (value) {
      if (!value) return ''

      return moment(value).format('LT');
    })

    Vue.filter('msm_year', function (value) {
      if (!value) return ''

      return moment(value).format('YYYY');
    })

    Vue.filter('msm_yearmonth', function (value) {
      if (!value) return ''

      return moment(value).format('YYYY-MM');
    })    
  }
}